// import R from 'ramda';
import activationtemplate from './activation.tpl.html';

export class Activation {
  constructor($scope, $ngRedux, actionsFactory, $state) {
    Object.assign(this, {
      $scope,
      $ngRedux,
      actionsFactory,
      $state,
    });
    const unsubscribe = $ngRedux.connect(this.mapStateToThis, actionsFactory)(this);
    $scope.$on('$destroy', unsubscribe);
  }

  $onInit() {
    this.token = this.$state.params.token;
    this.reqActivationStart(this.token);
    this.password = '';
    this.password_confirmation = '';
    this.err = '';
  }

  /* eslint-disable */
  mapStateToThis(state) {
    return {
      activation: state.activation,
    };
  }
  /* eslint-enable */

  sendPassword() {
    this.sendActivationPasswords(this.token, this.password, this.password_confirmation);
  }

  goLogin() {
    this.state('not-authenticated.login');
  }
}

Activation.$inject = [
  '$scope',
  '$ngRedux',
  'actionsFactory',
  '$state',
];

export const activation = {
  template: activationtemplate,
  controller: Activation,
};
